import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {HiOutlineQrcode} from "react-icons/hi";
import {TbBuildingStore, TbStatusChange} from "react-icons/tb";
import {BsCalendar2Check, BsCalendar4Week, BsInfoSquare} from "react-icons/bs";
import {PiTruckThin} from "react-icons/pi";
import {LiaEyeSolid} from "react-icons/lia";

import {IoMdCheckmarkCircleOutline} from "react-icons/io";



function OrderDetails() {
    const navigate = useNavigate();

    const {id} = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [readOnlyStatus, setReadOnlyStatus] = React.useState(true);
    const [factorNumber, setFactorNumber] = React.useState('');
    const [battery_qty, setQty] = React.useState(0);

    const [batteryQtyDetails, setQtyDetails] = React.useState([]);

    const [orderDescription, setOrderDescription] = React.useState('');
    const [order, setOrder] = React.useState([]);

    const [factor, setFactor] = React.useState([]);



    React.useEffect(() => {

        const params = {
            'processFor' : 'Sales',

        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);
                let descriptions = response.data.public_description;
                descriptions = descriptions?.replaceAll('***' , '<br/> - ');
                setOrderDescription(descriptions)
                setFactorNumber(response.data.factor_number);
                setQty(response.data.battery_qty);
                setQtyDetails(response.data.battery_qty_detail_vendor);
                setFactor(response.data.battery_qty_detail);
                setIsLoaded(true)

                if(response.data.last_status.id === 1 ||response.data.last_status.id === 13 ||response.data.last_status.id === 17  ) {
                    setReadOnlyStatus(false)
                }
            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                    setTimeout (() => {
                          window.history.back()
                    },400)
                }
                else {
                    toast.error(error.message);
                    setTimeout (() => {
                        window.history.back()
                    },400)
                }
            });


    }, [id]);

    const onSaleBackButtonClick = () => {

        let request = {
            'original_order_id' : id,
            'description' : 'ثبت از طرف نماینده',
            'processFor' : 'Vendors',
        }
        API.storeBOrder(request)
            .then((response) => {
                toast.success(response.message);
                setTimeout(() => {
                    navigate('/sb-orders/' + response.data.id);
                }, 2000);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }
    const onStatusButtonClick =  (statusId) => {
        setIsLoaded(false);
        const request = {
            order_id: id,
            description: 'تحویل از طرف نماینده',
            status_id : statusId,
            'processFor' : 'Sales',
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true);
            });
    }

    return (
        <React.Fragment>
            <Header/>

            <Navbar page="orders" public="1"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        مدیریت سفارش
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                        <div className="col-1">
                                            <TbBuildingStore />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            نماینده:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order?.vendor?.title}
                                            &nbsp;
                                            (
                                            {order?.vendor?.city}
                                            )
                                            {
                                                order?.vendor?.is_tropical ?
                                                    <span className='badge text-bg-warning mx-2 p-2'> گرمسیری</span>
                                                    : ""
                                            }
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد سفارش:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order.tracking_code}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <TbStatusChange />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            وضعیت سفارش
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2" style={{color: order?.last_status?.color}}>
                                            {order?.last_status?.title}

                                            {
                                                order?.last_status?.id === 14 &&
                                                <div>
                                                    <button
                                                        className="btn btn-outline-success text-center text-small-2 w-50 mt-3 p-2 pr-4 "
                                                        onClick={
                                                            () => {
                                                                onStatusButtonClick(15)
                                                            }
                                                        }
                                                        disabled={!isLoaded}
                                                    >
                                                        ثبت تحویل سفارش
                                                        &nbsp;
                                                        <strong className='text-small-2'>(تحویل از طرف نماینده)</strong>
                                                    </button>
                                                </div>
                                            }

                                            <div>
                                                {
                                                    (order?.last_status?.id === 14 || order?.last_status?.id === 15) &&

                                                            <button
                                                                className="btn btn-outline-warning text-center text-small-2 w-50 mt-3 p-2 pr-4 "
                                                                onClick={
                                                                    () => {
                                                                        onSaleBackButtonClick()
                                                                    }
                                                                }
                                                                disabled={!isLoaded}
                                                            >

                                                                ثبت  برگشت از فروش

                                                                &nbsp;
                                                                <strong className='text-small-2'>(ثبت از طرف نماینده)</strong>
                                                            </button>

                                                }
                                            </div>

                                        </div>


                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <BsCalendar4Week/>
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ ثبت
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                        {order.date}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <BsInfoSquare />
                                        </div>
                                        <div className="col-11 text-small-2">
                                            توضیحات سفارش
                                        </div>
                                        <div className="col-2 text-small-2">
                                           &nbsp;
                                        </div>
                                        <div className="col-10 text-end fw-bold text-small-2">

                                            <div className="content" dangerouslySetInnerHTML={{__html: orderDescription}}></div>

                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <PiTruckThin />
                                        </div>
                                        <div className="col-11 text-small-2">
                                           مشخصات راننده
                                        </div>
                                        <div className="col-2 text-small-2">
                                           &nbsp;
                                        </div>
                                        <div className="col-10 text-end fw-bold text-small-2">

                                            {order.driver_info}

                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <BsCalendar2Check />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ مورد نظر برای تحویل
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.vendor_suggest_date}
                                        </div>
                                    </div>
                                    <div className="col-12 mt-1">
                                        <div className=" ">
                                            <div className="card-header text-end text-small-2">
                                                 باتری های درخواستی نماینده
                                                &nbsp;

                                            </div>

                                            <div className="text-body-secondary text-small-1">
                                                {
                                                    batteryQtyDetails?.length > 0 &&
                                                    <table className="table  text-small-2">
                                                        <thead className='text-center'>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">برند</th>
                                                            <th scope="col">آمپراژ</th>
                                                            <th scope="col">نوع</th>
                                                            <th scope="col">تعداد</th>
                                                            <th scope="col">توضیحات</th>

                                                        </tr>
                                                        </thead>
                                                        <tbody className='text-center'>
                                                        {
                                                            batteryQtyDetails?.map((cart, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <td>{cart.brand}</td>
                                                                        <td>{cart.amperage}</td>
                                                                        <td>{cart.batteryType}</td>
                                                                        <td>{cart.count}</td>
                                                                        <td>{cart.batteryDescription}</td>

                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        </tbody>
                                                    </table>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-2 mt-2">


                                        <div className="form-floating col-md-6 mt-4">
                                            <input type="text"
                                                   className="form-control px-5 text-left"
                                                   id="username" name="username"
                                                   placeholder="شماره "
                                                   value={factorNumber}
                                                   readOnly={readOnlyStatus}
                                                   disabled={true}

                                            />
                                            <label htmlFor="mobile" className="right-0">شماره فاکتور سیستم
                                                حسابداری</label>
                                        </div>
                                        <div className="form-floating col-md-6 mt-4">
                                            <input type="number"
                                                   className="form-control px-5 text-left"
                                                   id="username" name="username"
                                                   placeholder="تعداد "
                                                   value={battery_qty}
                                                   disabled={true}

                                            />
                                            <label htmlFor="mobile" className="right-0">
                                                تعداد  کل باتری سفارش
                                            </label>
                                        </div>

                                        <div className="col-12 mt-4">
                                            <div className="card ">
                                                <div className="card-header text-end text-small-2">
                                                    لیست باتری های سفارش
                                                </div>

                                                <div className="card-footer text-body-secondary">
                                                    <div className='mb-4'>
                                                 <span className='alert alert-primary fade show text-small-2 py-1' role='button'
                                                       onClick={() => navigate(`/order-batteries/${id}`)}
                                                 >
                                                گزارش وضعیت باتری های این سفارش
                                                     &nbsp;
                                                     <LiaEyeSolid />
                                            </span>
                                                    </div>
                                                    <div className="card-footer text-body-secondary">
                                                        {
                                                            factor?.length > 0 &&
                                                            <table className="table table-striped text-small-2">
                                                                <thead className='text-center'>
                                                                <tr>
                                                                    <th scope="col">#</th>
                                                                    <th scope="col">برند</th>
                                                                    <th scope="col">آمپراژ</th>
                                                                    <th scope="col">نوع</th>
                                                                    <th scope="col">تعداد</th>
                                                                    <th scope="col">توضیحات</th>

                                                                </tr>
                                                                </thead>
                                                                <tbody className='text-center'>
                                                                {
                                                                    factor?.map((cart, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <th scope="row">{index + 1}</th>
                                                                                <td>{cart.brand}</td>
                                                                                <td>{cart.amperage}</td>
                                                                                <td>{cart.batteryType}</td>
                                                                                <td>{cart.count}</td>
                                                                                <td>{cart.batteryDescription}</td>

                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                                </tbody>
                                                            </table>
                                                        }


                                                    </div>

                                                </div>
                                            </div>
                                        </div>







                                        <div className="col-12 mt-4">
                                            <div className="card ">
                                                <div className="card-header text-end text-small-2">
                                                   اسناد و فایل ها
                                                </div>

                                                <div className="card-footer text-body-secondary">
                                                    {
                                                        order?.documents?.length > 0  &&
                                                        <ul className='text-small-3 text-muted opacity-75'>
                                                            <li>
                                                                لیست فایلها
                                                            </li>
                                                        </ul>
                                                    }


                                                    {
                                                        order?.documents?.map((doc, index) => {
                                                            return (
                                                                <span className="btn btn-dark mx-2 position-relative text-small-2 "
                                                                      key={index}

                                                                      onClick={() => {
                                                                          window.open(doc.path)
                                                                      }}
                                                                >
                                                                {doc.title}

                                                                    <span
                                                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary ">
      {Math.round(doc.file_size / 1000)}K

  </span>
                                                                </span>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">تاریخچه وضعیت های سفارش</h5>
                                    <div className="row">
                                        {
                                            order?.history?.map(stat => {
                                                return (
                                                    <div className='col-12 mt-2 bg-light text-small-1  p-2'>
                                                        <IoMdCheckmarkCircleOutline className='mx-2'
                                                                                    style={{color:stat.status.color }}
                                                        />
                                                        سفارش در تاریخ:
                                                        &nbsp;
                                                        {stat.date}
                                                        &nbsp;
                                                        توسط
                                                        &nbsp;
                                                        {stat.user.name}
                                                        &nbsp;
                                                        {stat.user.surname}
                                                        &nbsp;
                                                        در وضعیت
                                                        &nbsp;
                                                        <span className='fw-bold' style={{color:stat.status.color }}>
                                                            {stat.status.title}
                                                        </span>

                                                        &nbsp;
                                                        قرار گرفت.

                                                        <div className='fw-bold text-muted me-4 text-small-2 mt-3'>
                                                            {stat.description?.length > 2 ? stat.description : ''}
                                                        </div>
                                                    </div>
                                                )

                                            })

                                        }
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default OrderDetails;